import React, {ReactNode} from 'react';
import {Modal} from 'antd';
import CloseIconDialog from 'Components/CloseIconDialog';
import {useCSContext} from 'Context/ContentStackContext';

interface IProps {
  children: ReactNode;
  closeDialogMethod: any;
  open: any;
  id?: any;
  style?: any;
}

function DialogWrapper(props: IProps) {
  const {children, closeDialogMethod, open} = props;
  const {artifacts} = useCSContext();

  const handleClose = () => {
    closeDialogMethod(false);
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      // matches the original's disableEscapeKeyDown + "ignore backdrop click" behavior:
      // only the explicit close icon below can dismiss this dialog.
      closable={false}
      keyboard={false}
      maskClosable={false}
      footer={null}
      // antd's Modal is `position: relative` with `margin: 0 auto` (unlike the old MUI
      // `fullScreen` Dialog, which was `position: fixed; inset: 0`). Sizing this to
      // 100vw and then nudging it with a plain `left` offset — as a naive MUI->antd
      // port would — pushes an already-viewport-wide box off the right edge on every
      // screen size. Sizing to the remaining width and overriding the centering margin
      // instead reproduces the original "flush against the member-details sidebar,
      // spanning to the viewport's right edge" layout correctly. The offset must match
      // where Dashboard's main tab content actually starts (Pages/Dashboard/index.tsx),
      // not just MemberDetailsPanel's raw 24vw width: that sidebar's own root div also
      // carries `margin: 0.75rem 10px` (MemberDetailsPanel/index.tsx), and the flex row
      // has no gap of its own, so real content begins at 24vw + 10px (sidebar's own
      // right margin) + 10px (its left margin) = 24vw + 20px. Using bare 24vw here
      // clips this dialog's leftmost content underneath the sidebar's margin.
      width="calc(100vw - 24vw - 20px)"
      style={{
        top: 0,
        margin: 0,
        marginLeft: 'calc(24vw + 20px)',
        maxWidth: 'none',
        paddingBottom: 0,
        ...props.style,
      }}
      // antd's default `.ant-modal-container` padding is 16px top/bottom (paddingMD),
      // so the body below is sized to 100vh minus that, keeping the dialog's total
      // height exactly 100vh — otherwise the outer modal wrapper also becomes
      // scrollable on top of the body's own scroll, a confusing double-scroll that
      // hides/clips content. (Left as the default padding otherwise, so content isn't
      // flush against the dialog's own edges.)
      styles={{body: {height: 'calc(100vh - 32px)', overflow: 'auto', position: 'relative'}}}>
      <CloseIconDialog callback={handleClose} image={artifacts.cross_icon} />
      {children}
    </Modal>
  );
}

export default DialogWrapper;
